export const WIKI_ROLE_LABELS_BY_MODE = {
    "multi-tenant": {
        tenant_basic: "Básico",
        tenant_beta_full: "Beta Full",
        tenant_beta_lite: "Beta Lite",
        platform_admin: "Admin"
    }
};
